import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ExportacaoDadosAluno } from 'src/app/core/exportacao-dados-aluno';
import { ListaCompletaDadosExportar } from 'src/app/core/lista-completa-dados-exportar';
import { Rotas } from 'src/app/core/rotas';
import { FiltroExportacao } from '../../core/filtro/filtro-exportacao';
import { BaseService } from '../base/base.service';

const httpOptions = {
  'responseType'  : 'arraybuffer' as 'json'
};

@Injectable({
  providedIn: 'root'
})
export class ExportacaoDadosAlunoService  extends BaseService<ExportacaoDadosAluno> {

  constructor(http: HttpClient) {
    super(http, Rotas.EXPORTAR_DADOS_ALUNO);
  }


  gerarArquivo(lista: ListaCompletaDadosExportar) {
    return this.http.post(Rotas.EXPORTAR_DADOS_ALUNO + "gerar-arquivo", lista, httpOptions);
  }

  getFilter(cpf: string|number,
            nomeBeneficiario: string|number,
            nomeMae: string|number,
            nomePai: string|number,
            idPrograma: string|number,
            idProjeto: string|number,
            idUnidade: string|number,
            dataInicioEntradaInstituicao: any,
            dataFimEntradaInstituicao: any) {

    cpf             = cpf || '';
    nomeBeneficiario  = nomeBeneficiario || '';
    nomeMae           = nomeMae || '';
    nomePai           = nomePai || '';
    idPrograma      = idPrograma || '';
    idProjeto       = idProjeto || '';
    idUnidade       = idUnidade || '';

    const p_dataInicioEntradaInstituicao = dataInicioEntradaInstituicao ? dataInicioEntradaInstituicao.getTime() : '';
    const p_dataFimEntradaInstituicao = dataFimEntradaInstituicao ? dataFimEntradaInstituicao.getTime() : '';

    return this.http.get(Rotas.EXPORTAR_DADOS_ALUNO + 'filter', { params: {
      cpf: `${cpf}` ,
      nomeBeneficiario: `${nomeBeneficiario}` ,
      nomeMae: `${nomeMae}`,
      nomePai: `${nomePai}`,
      idPrograma: `${idPrograma}`,
      idProjeto: `${idProjeto}`,
      idUnidade: `${idUnidade}`,
      dataInicioEntradaInstituicao: `${p_dataInicioEntradaInstituicao}`,
      dataFimEntradaInstituicao: `${p_dataFimEntradaInstituicao}`,
      }
    });
  }

  getRelatorioHistoricoBeneficiario(cpf: string|number,
    beneficiario: string|number,
    dataInicioEntradaInstituicao: any,
    dataFimEntradaInstituicao: any,) {

    cpf = cpf || '';
    beneficiario = beneficiario || '';

    const p_dataInicioEntradaInstituicao = dataInicioEntradaInstituicao ? dataInicioEntradaInstituicao.getTime() : '';
    const p_dataFimEntradaInstituicao = dataFimEntradaInstituicao ? dataFimEntradaInstituicao.getTime() : '';

    return this.http.get(Rotas.EXPORTAR_DADOS_ALUNO + 'historico/beneficiario', { params: {
        cpf: `${cpf}` ,
        beneficiario: `${beneficiario}` ,
        dataInicioEntradaInstituicao: `${p_dataInicioEntradaInstituicao}`,
        dataFimEntradaInstituicao: `${p_dataFimEntradaInstituicao}`,
      }
    });
}

  listFiltered(filtro: FiltroExportacao) {
    return this.http.post(
      Rotas.EXPORTAR_DADOS_ALUNO + 'filtro', 
      JSON.stringify(filtro),
      this.headers()
    );
  }
}
